import InfoIcon from '@mui/icons-material/Info';
import { Box, Grid2 as Grid, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import React, { useContext } from 'react';
import { BookingStore } from '../../../utils/stores/BookingStore';
import { ProductsStore } from '../../../utils/stores/ProductsStore';
import PackageDateTimeSelect from './PackageDateTimeSelect';
import { commonStyles } from './commonStyles';

export default function CustomerDetails() {
    const bookingController = useContext(BookingStore);
    const productController = useContext(ProductsStore);

    return (
        <Box sx={commonStyles.container}>
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h4" sx={commonStyles.title}>
                        Tell us a bit about yourself
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Typography sx={commonStyles.subtitle}>
                        Your details will be used as the primary contact for the booking
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }} sx={commonStyles.fieldInputSection}>
                    <TextField
                        label="First Name"
                        variant="outlined"
                        error={bookingController.customerErrors.firstName !== undefined}
                        helperText={bookingController.customerErrors.firstName}
                        sx={commonStyles.fieldInputItem}
                        color="primary"
                        required
                        name="firstName"
                        value={bookingController.booking.customer.firstName}
                        onChange={(event) => bookingController.handleCustomerChange(event)}
                        onBlur={(event) => bookingController.handleCustomerChange(event)}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }} sx={commonStyles.fieldInputSection}>
                    <TextField
                        label="Surname"
                        variant="outlined"
                        error={bookingController.customerErrors.lastName !== undefined}
                        helperText={bookingController.customerErrors.lastName}
                        sx={commonStyles.fieldInputItem}
                        color="primary"
                        required
                        name="lastName"
                        value={bookingController.booking.customer.lastName}
                        onChange={(event) => bookingController.handleCustomerChange(event)}
                        onBlur={(event) => bookingController.handleCustomerChange(event)}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }} sx={commonStyles.fieldInputSection}>
                    <TextField
                        label="Email"
                        variant="outlined"
                        error={bookingController.customerErrors.email !== undefined}
                        helperText={bookingController.customerErrors.email}
                        sx={commonStyles.fieldInputItem}
                        color="primary"
                        required
                        name="email"
                        value={bookingController.booking.customer.email}
                        onChange={(event) => bookingController.handleCustomerChange(event)}
                        onBlur={(event) => bookingController.handleCustomerChange(event)}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }} sx={commonStyles.fieldInputSection}>
                    <TextField
                        label="Phone"
                        variant="outlined"
                        error={bookingController.customerErrors.phone !== undefined}
                        helperText={bookingController.customerErrors.phone}
                        sx={commonStyles.fieldInputItem}
                        color="primary"
                        required
                        name="phone"
                        value={bookingController.booking.customer.phone}
                        onChange={(event) => bookingController.handleCustomerChange(event)}
                        onBlur={(event) => bookingController.handleCustomerChange(event)}
                    />
                </Grid>
                {bookingController.booking.isPackage && (
                    <Grid container sx={commonStyles.fieldInputSection}>
                        <Box style={{ display: 'flex' }}>
                            <InfoIcon
                                color="primary"
                                fontSize="large"
                                style={{ marginRight: 15, marginTop: 15, fontSize: '2rem' }}
                            />
                            <Typography
                                variant="h6"
                                style={{ margin: '15px 0 10px', opacity: 0.9, width: '100%' }}
                                color="primary"
                            >
                                Let&apos;s organise the rest of your package.
                            </Typography>
                        </Box>
                        <Typography sx={commonStyles.subtitle} style={{ width: '100%' }}>
                            Select a departure date and time for the {productController.product.packageProductNames[1]}
                        </Typography>
                        <PackageDateTimeSelect />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
}
